var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2416_90896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2166 5.57251H25.8105V19.8404H67.5649V12.9179C67.5649 8.86726 64.2684 5.57251 60.2166 5.57251Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7414 22.0362H0.5V8.79707C0.5 3.94592 4.44764 0 9.30051 0H22.1671C23.446 0 24.6779 0.269508 25.7972 0.775909C27.3604 1.48029 28.7034 2.6413 29.6452 4.15821L40.7414 22.0362Z",
    fill: "#BBC2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 24.9998V67.645C75.5 71.7008 72.1984 74.9996 68.1409 74.9996H7.85912C3.80162 74.9996 0.5 71.7008 0.5 67.645V17.6435H68.1409C72.1984 17.6435 75.5 20.9434 75.5 24.9998Z",
    fill: "#8D99DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 24.9998V67.645C75.5 71.7008 72.1984 74.9996 68.1409 74.9996H38V17.6435H68.1409C72.1984 17.6435 75.5 20.9434 75.5 24.9998Z",
    fill: "#8D99DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7265 46.3215C57.7265 57.2008 48.8762 66.0517 37.998 66.0517C27.1198 66.0517 18.2695 57.2008 18.2695 46.3215C18.2695 35.4439 27.1198 26.593 37.998 26.593C48.8762 26.593 57.7265 35.4439 57.7265 46.3215Z",
    fill: "#E7ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7285 46.3215C57.7285 57.2008 48.8782 66.0517 38 66.0517V26.593C48.8782 26.593 57.7285 35.4439 57.7285 46.3215Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.359 46.5631C43.9476 46.9115 43.4435 47.0815 42.944 47.0815C42.3185 47.0815 41.6971 46.8165 41.2623 46.3004L40.1974 45.0381V53.3025C40.1974 54.5156 39.2132 55.4998 38.0001 55.4998C36.787 55.4998 35.8029 54.5156 35.8029 53.3025V45.0381L34.738 46.3004C33.9541 47.228 32.5688 47.3464 31.6412 46.5631C30.7142 45.7809 30.5952 44.395 31.3774 43.4674L35.7267 38.3113C36.2938 37.6407 37.1212 37.255 38.0001 37.255C38.879 37.255 39.7064 37.6407 40.2735 38.3113L44.6228 43.4674C45.405 44.395 45.286 45.7809 44.359 46.5631Z",
    fill: "#040031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3589 46.5631C43.9475 46.9115 43.4434 47.0815 42.9438 47.0815C42.3184 47.0815 41.697 46.8165 41.2621 46.3004L40.1973 45.0381V53.3025C40.1973 54.5156 39.2131 55.4998 38 55.4998V37.255C38.8789 37.255 39.7063 37.6407 40.2734 38.3113L44.6227 43.4674C45.4049 44.395 45.2859 45.7809 44.3589 46.5631Z",
    fill: "#040031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2416_90896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/iconUpload.92b167014d96a9de14f39ee0b85899b3.svg";
export { ForwardRef as ReactComponent };